
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The Language List is the <strong>language selector</strong> of the European
  Commission sites. Users are presented with the language list when they first
  access the site, or through the language switcher at the top-right corner of
  any page.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`There are `}<strong parentName="p">{`2 versions`}</strong>{` of the component. One version is shown initially when a user arrives at the site. The second version is for a user to switch their language preference.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`desktop is a 2 column layout`}</strong>{` which displays the available language choices`}</li>
      <li parentName="ul"><strong parentName="li">{`mobile design is a single column layout`}</strong>{` which allows the user to scroll to select their language`}</li>
    </ul>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/LanguageList/Language%20list2.jpg" alt="Anatomy of language list" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Icon + Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading indicating the required action accompanied by icon (translated in every language)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Language list`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of the available languages`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Button to close without making a selection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Active selection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Current language selection`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`match the label`}</strong>{` of the language with the selected language`}</li>
      <li parentName="ul"><strong parentName="li">{`display only the languages`}</strong>{` in which the content has been `}<strong parentName="li">{`translated`}</strong>{` in and is `}<strong parentName="li">{`available`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`indicate current language`}</strong></li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't display languages`}</strong>{` as options in the language list `}<strong parentName="li">{`if they are not available`}</strong>{` on your site`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`this is a site-wide component`}</strong>{` and thus it `}<strong parentName="li">{`must be available on every page`}</strong>{` in case users want to switch their language preference`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`should be used on every page`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;